export default "__VITE_ASSET__DGJqvCRz__"